"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToPolicyResultCellRenderer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/Grid/types");
require("@veeam/components/lib/Tooltip/types");
const components_2 = require("../../../../../../components");
const constants_1 = require("../../../../../../constants");
require("../types");
const getStatusIconSrc_1 = require("./getStatusIconSrc");
const TooltipText = styled_components_1.default(components_1.Text) `
  max-width: ${({ maxWidth }) => maxWidth};
  word-break: break-word;
  overflow: hidden;
`;
function addToPolicyResultCellRenderer() {
    return function cellRenderer({ cellData, rowData, columnWidth = 0, }) {
        const ref = react_1.useRef(null);
        const iconSrc = rowData.status && getStatusIconSrc_1.getStatusIconSrc(rowData.status);
        return components_1.useTooltip({
            delayTimeout: 500,
            renderContent: () => {
                return (react_1.default.createElement(TooltipText, { size: components_1.TEXT_SIZE.s, maxWidth: `${columnWidth + 50}px` }, cellData));
            },
            isActive: !!cellData,
            render: (_a) => {
                var { ref: r } = _a, tooltipProps = __rest(_a, ["ref"]);
                return (react_1.default.createElement(components_2.TruncatedText, Object.assign({}, tooltipProps, { ref: ref }),
                    react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.s },
                        iconSrc && react_1.default.createElement(components_1.Icon, { src: iconSrc }),
                        react_1.default.createElement(components_1.Text, { truncate: true }, cellData || constants_1.EMPTY_TEXT.dash))));
            },
        });
    };
}
exports.addToPolicyResultCellRenderer = addToPolicyResultCellRenderer;
//# sourceMappingURL=addToPolicyResultCellRenderer.js.map